/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CopropertyAddressDto
 */
export interface CopropertyAddressDto {
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressDto
     */
    ligne1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressDto
     */
    ligne2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressDto
     */
    ligne3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressDto
     */
    codePostal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressDto
     */
    ville?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressDto
     */
    pays?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressDto
     */
    adresseFormattee?: string | null;
}

/**
 * Check if a given object implements the CopropertyAddressDto interface.
 */
export function instanceOfCopropertyAddressDto(value: object): value is CopropertyAddressDto {
    return true;
}

export function CopropertyAddressDtoFromJSON(json: any): CopropertyAddressDto {
    return CopropertyAddressDtoFromJSONTyped(json, false);
}

export function CopropertyAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopropertyAddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'ligne1': json['ligne1'] == null ? undefined : json['ligne1'],
        'ligne2': json['ligne2'] == null ? undefined : json['ligne2'],
        'ligne3': json['ligne3'] == null ? undefined : json['ligne3'],
        'codePostal': json['codePostal'] == null ? undefined : json['codePostal'],
        'ville': json['ville'] == null ? undefined : json['ville'],
        'pays': json['pays'] == null ? undefined : json['pays'],
        'adresseFormattee': json['adresseFormattee'] == null ? undefined : json['adresseFormattee'],
    };
}

export function CopropertyAddressDtoToJSON(json: any): CopropertyAddressDto {
    return CopropertyAddressDtoToJSONTyped(json, false);
}

export function CopropertyAddressDtoToJSONTyped(value?: CopropertyAddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'ligne1': value['ligne1'],
        'ligne2': value['ligne2'],
        'ligne3': value['ligne3'],
        'codePostal': value['codePostal'],
        'ville': value['ville'],
        'pays': value['pays'],
        'adresseFormattee': value['adresseFormattee'],
    };
}

